<div class="layout">
  <!-- Sidebar -->
  <aside class="sidebar" [class.collapsed]="sidebarCollapsed">
    <div class="sidebar-header">
      <div class="brand">
        <div class="brand-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z"/>
          </svg>
        </div>
        <div class="brand-text" *ngIf="!sidebarCollapsed">
          <span class="brand-name">Master Team</span>
          <span class="brand-sub">Ideas Hub</span>
        </div>
      </div>
      <button type="button" class="collapse-btn" (click)="sidebarCollapsed = !sidebarCollapsed" [attr.aria-label]="sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
        <svg class="collapse-icon" [class.expanded]="sidebarCollapsed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
      </button>
    </div>

    <nav class="nav-menu" [class.collapsed]="sidebarCollapsed">
      <a routerLink="/feed" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" class="nav-item" [title]="sidebarCollapsed ? 'Home / Feed' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Home / Feed</span>
      </a>
      <a routerLink="/submit-idea" routerLinkActive="active" class="nav-item" [title]="sidebarCollapsed ? 'Submit Idea' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Submit Idea</span>
      </a>
      <a routerLink="/challenges" routerLinkActive="active" class="nav-item" [title]="sidebarCollapsed ? 'Challenges' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-2v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Challenges</span>
      </a>
      <a routerLink="/my-ideas" routerLinkActive="active" class="nav-item" [title]="sidebarCollapsed ? 'My Ideas' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">My Ideas</span>
      </a>
      <a routerLink="/following" routerLinkActive="active" class="nav-item" [title]="sidebarCollapsed ? 'Following' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Following</span>
      </a>
      <a *ngIf="canAccessCommitteeBoard" routerLink="/committee/review-board" routerLinkActive="active" class="nav-item" [title]="sidebarCollapsed ? 'Committee Review' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 15l-4-4 1.41-1.41L11 13.17l6.59-6.59L19 8l-8 8z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Committee Review</span>
      </a>
      <a routerLink="/leaderboard" routerLinkActive="active" class="nav-item" [title]="sidebarCollapsed ? 'Leaderboard' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Leaderboard</span>
      </a>
      <a routerLink="/analytics" routerLinkActive="active" class="nav-item" [title]="sidebarCollapsed ? 'Analytics' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Analytics</span>
      </a>
      <a routerLink="/settings" routerLinkActive="active" class="nav-item" [title]="sidebarCollapsed ? 'Settings' : ''">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>
        </span>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Settings</span>
      </a>
    </nav>

    <div class="sidebar-user" [class.collapsed]="sidebarCollapsed">
      <img
        src="assets/masterteam_sa_logo.jpeg"
        alt="Master Team"
        class="user-avatar"
        [attr.title]="userDisplayName + ' — ' + userRoleLabel"
      />
      <div class="user-info" *ngIf="!sidebarCollapsed">
        <span class="user-name">{{ userDisplayName }}</span>
        <span class="user-role">{{ userRoleLabel }}</span>
      </div>
    </div>
  </aside>

  <!-- Main content -->
  <div class="main">
    <header class="header">
      <div class="search-bar" *ngIf="showNavbarSearch">
        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
        <input type="search" placeholder="Search ideas..." class="search-input" />
      </div>
      <div class="header-actions">
        <a routerLink="/submit-idea" class="btn-new-idea"> 
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
           New Idea
        </a>
        <div class="notifications-wrap" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="btn-icon notification-btn"
            aria-label="Notifications"
            (click)="toggleNotifications($event)"
            [attr.aria-expanded]="notificationsOpen"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>
            <span class="badge" *ngIf="unreadNotificationsCount > 0">{{ unreadNotificationsCount }}</span>
          </button>

          <div *ngIf="notificationsOpen" class="notifications-menu" role="menu" aria-label="Notifications">
            <div class="notifications-header">
              <div class="notifications-title">Notifications</div>
              <button
                *ngIf="unreadNotificationsCount > 0"
                type="button"
                class="notifications-refresh"
                (click)="markAllNotificationsAsRead($event)"
                [disabled]="markingAllNotificationsRead"
              >
                {{ markingAllNotificationsRead ? 'Marking...' : 'Mark all read' }}
              </button>
            </div>

            <div *ngIf="notificationsLoading" class="notifications-loading">Loading…</div>
            <div *ngIf="!notificationsLoading && notificationsError" class="notifications-error">{{ notificationsError }}</div>

            <div *ngIf="!notificationsLoading && !notificationsError && notifications.length === 0" class="notifications-empty">
              You're all caught up.
            </div>

            <div *ngIf="!notificationsLoading && !notificationsError && notifications.length > 0" class="notifications-list">
              <a
                *ngFor="let n of notifications"
                href="#"
                class="notification-item"
                role="menuitem"
                [class.unread]="!n.isRead"
                (click)="openNotification(n, $event)"
              >
                <div class="notification-main">
                  <div class="notification-title">{{ n.title }}</div>
                  <div class="notification-message">{{ n.message }}</div>
                </div>
                <div class="notification-meta">
                  <span class="notification-time">{{ formatTimeAgo(n.createdAtUtc) }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="header-user">
          <img src="assets/masterteam_sa_logo.jpeg" alt="Master Team" class="user-avatar small" />
          <span class="user-name">{{ userDisplayName }}</span>
        </div>
        <button type="button" class="btn-logout" (click)="logout()">Logout</button>
      </div>
    </header>

    <main class="content">
      <router-outlet />
    </main>
  </div>
</div>
